var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/App.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal } from 'Components/utility';
const mapState = ({
  nav: {
    location,
    initErrorStatus,
    initErrorCode,
    redirect_uri,
    data
  }
}) => {
  return {
    initErrorStatus,
    initErrorCode,
    redirect_uri,
    location,
    data
  };
};
const connector = connect(mapState);
const App = ({
  initErrorStatus,
  initErrorCode,
  redirect_uri,
  location,
  data
}) => {
  const {
    Component,
    props
  } = useRouter(location, initErrorStatus, initErrorCode, redirect_uri, data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(GeneralModal, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }));
};
export default connector(App);